import { schema } from 'normalizr'

export const devicesSchema = new schema.Entity('devices')
